import { render, staticRenderFns } from "./TravelFilesFormats.vue?vue&type=template&id=c6e12872"
import script from "./TravelFilesFormats.vue?vue&type=script&lang=js"
export * from "./TravelFilesFormats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports